import Behavior from './behavior';
export default Behavior;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g6-core/es/behavior/index.js
// module id = null
// module chunks = 